import React from 'react'

class EmailInput extends React.Component{
    state = {
      emailList: ["gmail.com","hotmail.com","outlook.com","yahoo.com","live.com","globo.com.br","bol.com.br","terra.com.br","outro"],
      email:0,
      emailManual:"",
      suffix:0,
      name:"",
      loaded:false
    }

    componentWillReceiveProps(props){
      // SET STARTING EMAIL AND SUFFIX
      console.log(props)
      let fullEmail = props.value
      if(!this.state.loaded && fullEmail && fullEmail.split("@")[0] != "" && fullEmail.indexOf("undefined") == -1){
        this.setState({loaded:true})
        let name = fullEmail.split("@")[0]
        let email = fullEmail.split("@")[1]
        let index = this.state.emailList.indexOf(email)
        if(index == -1){
          this.setState({emailManual:email,name:name,email:this.state.emailList.length - 1},this.updateValue)
        }else{
          this.setState({email:this.state.emailList.indexOf(email),name:name},this.updateValue)
        }
      }
    }

    componentWillMount(){
      // CREATING MENU ITEMS
      let emailItems = []
      let suffixItems = []

      this.state.emailList.forEach((value,key) =>{
        emailItems.push(<option value={key}>{value}</option>)
      })

      let fullEmail = this.props.email
      if(fullEmail && fullEmail.split("@")[0] != "" && fullEmail.indexOf("undefined") == -1){
        let name = fullEmail.split("@")[0]
        let email = fullEmail.split("@")[1]
        let index = this.state.emailList.indexOf(email)
        if(index == -1){
          this.setState({emailManual:email,name:name,email:this.state.emailList.length - 1},this.updateValue)
        }else{
          this.setState({email:this.state.emailList.indexOf(email),name:name},this.updateValue)
        }
      }

      this.setState({emailItems:emailItems},this.props.onChange({target:{id:"email",value:this.state.name + "@" + this.state.emailList[this.state.email]}}))
    }

    storeValue = (event) => {
      this.setState({[event.target.id]:event.target.value},() => this.updateValue())
    }

    updateValue = () =>{
      let value = ""
      if(this.state.email == this.state.emailList.length - 1){
        value = this.state.name + "@" + this.state.emailManual
      }else{
        value = this.state.name + "@" + this.state.emailList[this.state.email]
      }
      this.props.onChange({target:{id:this.props.id,value:value}})
    }

    render(){
        return(
            <div style={{display:"flex", margin:"-5px", alignItems:"center"}}>
              <input style={{flex:1,margin: 5,borderColor:this.props.style.borderColor}} className="form-control" placeholder={"Email"} id="name" inputProps={{name:'name'}} value={this.state.name} onChange={(event) => this.storeValue(event)}/>
              @
              {this.state.email == this.state.emailList.length - 1?
                <input style={{flex:1, margin:5}} className="form-control" placeholder={"Provedor"} id="emailManual" inputProps={{name:'emailManual'}} value={this.state.emailManual} onChange={(event) => this.storeValue(event)}/>
              :
                <select style={{flex:1, margin:5, borderColor:this.props.style.borderColor}} className="form-control" inputProps={{name:'email'}} id="email" value={this.state.email} onChange={(event) => this.storeValue(event)}>
                  {this.state.emailItems}
                </select>}
            </div>
        )
    }
}

export default EmailInput



// WEBPACK FOOTER //
// ./src/inputs/EmailInput.js